import { ValueGetterParams } from 'ag-grid-community';
import { memoize } from 'lodash';

export const taskValueGetter = memoize(
  (params: ValueGetterParams) => params.data,
  (params) => {
    if (params.data == null) {
      return 'null';
    }
    const {
      status,
      progress,
      taskTree,
      taskName,
      taskId,
      type,
      formInstanceId,
    } = params.data;

    return [
      status,
      progress,
      (taskTree ?? []).map(({ taskName: n }) => n).join('::'),
      taskName,
      taskId,
      type,
      formInstanceId,
    ].join(':');
  },
);
